<template>
    <div class="bg-ternary">
        <div
                class="py-10 md:py-20 px-6 lg:max-w-4xl lg:mx-auto text-button-border"
        >
            <p class="ts font-bold line120">Contact</p>
            <Underline class="bg-accent"/>
            <p class="text-base md:text-2xl">
                If you need more information about our mission at the GoldenRace
                Foundation do not hesitate to contact us and we will answer any doubt
                you may have.
            </p>
            <form
                    class="flex flex-col px-0 md:px-20 py-20 text-black mx-auto"
                    accept-charset="UTF-8"
                    v-on:submit.prevent="onSubmit()"
                    method="POST"
                    id="ajaxForm"
            >
                <p class="text-base text-white" v-if="$v.name.$error">Name is invalid.</p>
                <input
                        type="text"
                        name="name"
                        v-model.trim="$v.name.$model"
                        placeholder="Name"
                        id="input-name"
                        :class="{ 'border-red': $v.name.$error }"
                        class="px-4 py-1 mb-8 bg-gray-100 focus:bg-white border-b-4 focus:border-accent transition-colors duration-300"
                />

                <p class="text-base text-white" v-if="$v.email.$error">Email is invalid.</p>
                <input
                        type="text"
                        name="email"
                        v-model.trim="$v.email.$model"
                        placeholder="Email"
                        id="input-email"
                        :class="{ 'border-red': $v.email.$error }"
                        class="px-4 py-1 mb-8 bg-gray-100 focus:bg-white border-b-4 focus:border-accent transition-colors duration-300"
                />

                <p class="text-base text-white" v-if="$v.message.$error">Message should be at least 10
                    characters.</p>
                <textarea
                        type="text"
                        name="message"
                        v-model.trim="$v.message.$model"
                        placeholder="What's your query"
                        id="input-message"
                        :class="{ 'border-red': $v.message.$error }"
                        class="px-4 py-1 h-40 mb-8 bg-gray-100 focus:bg-white border-b-4 focus:border-accent transition-colors duration-300"
                />

                <div class="flex flex-col md:flex-row justify-between items-center">
                    <label class="input-terms flex text-white self-start md:self-center">
            <span class="select-none"
            >By submitting this form, I accept the
              <router-link to="/terms" class="link" target="_blank">terms</router-link> and
              <router-link to="/privacy" class="link" target="_blank">privacy policy</router-link> of this page.
            </span>
                    </label>

                    <Button name="Send" type="submit" hasBorder class="mt-6 md:mt-0"
                            :class="{ 'hidden' : isSuccess }"/>
                    <p class="text-base md:text-2xl text-white  pt-6" v-if="isSuccess">
                        Thanks for contact us! We will answer you soon
                    </p>
                </div>
            </form>
        </div>
    </div>
</template>

<style scoped>
    .input-terms input:checked + svg {
        opacity: 1;
    }

    .link {
        color: #DEE598;
    }

    .border-red {
        border-color: #E3022A;
    }
</style>

<script>
    import Underline from "@/components/parts/Underline";
    import Button from "@/components/Button";
    import {required, email, minLength} from "vuelidate/lib/validators";
    import axios from "axios";

    // Vue.use(VueReCaptcha, {siteKey: '6LcDtQAVAAAAAG34YWNdLGw_08y3QvRycMd_NiLV'})

    export default {
        name: "Contact",
        components: {
            Underline,
            Button,
        },
        data() {
            return {
                loading: true,
                name: "",
                email: "",
                message: "",
                platform: "",
                isSuccess: false
            };
        },
        validations: {
            name: {required, minLength: minLength(1)},
            email: {required, email},
            message: {required, minLength: minLength(10)},
        },
        methods: {
            onSubmit() {

                let data = {
                    name: this.name,
                    email: this.email,
                    message: this.message
                };

                axios
                    .post("https://getform.io/f/42d83405-8b28-4734-90fa-7694abaadd85", data, {
                        headers: {
                            Accept: "application/json"
                        }
                    })
                    .then(
                        res => {
                            this.isSuccess = res.data.success;
                            this.isSuccess = true;
                        }
                    )
                    .finally(() => {
                        this.name = "";
                        this.email = "";
                        this.message = "";
                        this.isSuccess = true;
                        this.$v.$reset();
                    });
            },
        },
    };
</script>
